import React from 'react'
import { Callout } from '@node-space/ui-components'

interface BankAccountRequirmentsCalloutProps {
  calloutMessage: string
}

export const BankAccountRequirmentsCallout = ({
  calloutMessage,
}: BankAccountRequirmentsCalloutProps) => {
  return (
    <Callout variant="warning">
      <p className="text-body-regular text-inherit">{calloutMessage}</p>
    </Callout>
  )
}
